import { List } from '@kerfjs/ui/list';
import { Text } from '@kerfjs/ui/text';
import { TextField } from '@kerfjs/ui/text-field';
import { type SafeHtml } from 'kerfjs';

import { num } from './settings-value.js';

/**
 * Landed-cost percentage defaults. Exchange rates live on the Currencies page.
 */
export function LandedCostAssumptionsView({ assumptions }: { assumptions: Record<string, unknown> }): SafeHtml {
  return (
    <List gap="m" controlInsets="rl">
      <Text tone="quiet" size="compact">
        Defaults — edit to your figures. Exchange rates are managed under Currencies.
      </Text>
      <TextField name="a_insurancePct" label="Insurance %" type="number" value={num(assumptions.insurancePct)} />
      <TextField name="a_customsDutyPct" label="Customs Duty %" type="number" value={num(assumptions.customsDutyPct)} />
      <TextField name="a_salesTaxPct" label="Sales Tax %" type="number" value={num(assumptions.salesTaxPct)} />
      <TextField
        name="a_financingCostPct"
        label="Financing %"
        type="number"
        value={num(assumptions.financingCostPct)}
      />
    </List>
  );
}
